<div class="card mb-4" id="folios-container">
    <div class="card-header">
        <div class="d-flex align-items-center mb-0">
            <div class="symbol symbol-40 symbol-dark-primary mr-5">
                <span class="symbol-label">
                    <span [inlineSVG]="'./assets/media/svg/icons/Home/Book.svg'" cacheSVG="true"
                        class="svg-icon svg-icon-xl svg-icon-primary"></span>
                </span>
            </div>
            <div class="d-flex flex-column font-weight-bold">
                <h4 class="text-dark text-hover-primary mb-1 font-size-xl"> Resumen Folios</h4>
                <span class="text-muted">Tipos de documentos y los folios restantes</span>
            </div>
        </div>
        <!-- <h4 class="card-title mb-0">
            Resumen Folios
        </h4> -->
    </div>
    <div class="card-content mb-5 mt-5">
        <div class="card-body">
            <div class="row form-group mx-auto mb-5 mt-5">
                <div class="col-8">
                    <h6 class="text-muted">Tipo de documento</h6>
                </div>
                <div class="col-4">
                    <h6 class="text-muted text-center">Folios restantes</h6>
                </div>
            </div>
            <ng-container *ngIf="listFolioResumen">
                <div *ngFor="let tipo of listFolioResumen">
                    <div class="row form-group mx-auto mb-10 mt-10">
                        <div class="col-8">
                            <h4 class="font-weight-bold">{{tipo.nombre}}</h4>
                        </div>
                        <div class="col-4 text-center">
                            <h4>
                                <span class="fs-4 badge rounded-pill bg-primary text-light" [ngClass]="{
                                        'bg-primary':(tipo.suma)>0,
                                        'bg-danger':(tipo.suma)<=0
                                    }"> {{+(tipo.suma | number : '1.0-0':'es')>0?(tipo.suma | number :
                                    '1.0-0':'es'):0}}</span>
                            </h4>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="loadingFoliosSummary$ | async">
                <div class="row">
                    <div class="offset-5 col-1">
                        <span class="spinner spinner-primary spinner-lg ml-5"></span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>